import $, { extend } from 'jquery';
import React from 'react';
import UserToken from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod} from '../function_lib/common_lib';
import Header from './header';
import Footer from './footer';
import LogoImg from '../assets/images/logo_p_small.png';
import defaultPic from '../assets/images/9.png';


let loginUser="";
let userObject="";
let companyName="";
let clsObject;
class List_Employes extends React.Component{
    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          UserToken.setUserObject(localStorage.getItem("userData"));
          userObject= UserToken.getUserObject();
          loginUser=userObject[0].person_name;
          companyName=userObject[0].company_name;
          //window.location.href="./Dashboard";
        }
      }
      callBackNg(data,msg){
         // alert(data);
        if(data.trim()!=="" && data.trim()!=="0"){
          var listItems=JSON.parse(data);
          var str="";
          var countEmp=0;
          for(var i=0;i<listItems.length;i++){
              countEmp++;
            str+="<tr>"+
             "<td>"+listItems[i]["user_name"]+"</td>"+
             "<td>"+listItems[i]["person_name"]+"</td>"+
             "<td>"+listItems[i]["role"]+"</td>"+
             "<td>"+listItems[i]["contact_no"]+"</td>"+
             "<td>"+listItems[i]["pan_no"]+"</td>"+
             "<td>"+listItems[i]["gstin_no"]+"</td>"+
             "<td>"+listItems[i]["password"]+"</td>"+
             "<td>"+listItems[i]["address"]+"</td>"+
             "<td>"+listItems[i]["details"]+"</td>"+
             "</tr>"
          }
          $("#tbData").html(str);
          $(".total_emp").html(countEmp);
        }
    }
 getEmployeeList(){
    var map=[];
    map.push({name:"curl_type",value:"getUserStaff"});
    map.push({name:"res_func",value:"callBackNg"});
    map.push({name:"local_token",value:userObject[0].app_user_id});
    map.push({name:"ref2_id",value:userObject[0].id});
    map["res_func"]="callBackNg";
    map["curl_type"]="getUserStaff";
    CallMapMethod(this,map);
 }   
componentDidMount(){
    clsObject=this;
 this.getEmployeeList();
 /*
  var empCategory=[];
  empCategory.push({name:"curl_type",value:"getEmployeeCategory"});
  empCategory.push({name:"res_func",value:"callBackEmpCate"});
  empCategory.push({name:"local_token",value:userObject[0].app_user_id});
  empCategory.push({name:"ref2_id",value:userObject[0].id});
  empCategory["res_func"]="callBackEmpCate";
  empCategory["curl_type"]="getEmployeeCategory";
  CallMapMethod(this,empCategory);
*/
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
}
callBackEmpCate(data,msg){
    //alert(data);
    var listEmpCategor=JSON.parse(data);
    var strTmp="<option value=\"0\">-select-</option>";
    for(var l=0;l<listEmpCategor.length;l++){
        strTmp+="<option value=\""+listEmpCategor[l]["id"]+"\">"+listEmpCategor[l]["category_name"]+"</option>"
    }
    $("#party_mapping_id").html(strTmp);

}
okSucc(data,msg){
    //alert(data+"===="+msg);
    if(data==="001"){

        $("#frmCreate").find("input[type=text]").val("");
        //$("#frmCreate").find()
        $(".respSSL").html(msg);
        clsObject.getEmployeeList();
    }else{
        $(".respSSL").html(msg);
    }
}
      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
<div className="row">
<div className="col-md-2"> 
        
        {/* <!-- Widget: user widget style 2 --> */}
        <div className="card card-widget widget-user-2 shadow "> 
          {/* <!-- Add the bg color to the header using any of the bg-* classNamees --> */}
          
          <div className="card-footer p-0">
            <ul className="nav flex-column  table-hover">
              <li className="nav-item"> <a href="javascript:void(0)" className="nav-link  hover"><h6><i className="fa fa-user-alt font-small text-orange"></i><span class="float-left badge bg-primary" data-toggle="modal" data-target="#divEmployee">Add New</span></h6> </a> </li>
            </ul>
          </div>
          
          {/* <!-- /.widget-user -->  */}
        </div>
        
        {/* <!-- Widget: user widget style 2 --> */}
        <div className="card card-widget widget-user-2 shadow "> 
          {/* <!-- Add the bg color to the header using any of the bg-* classNamees --> */}
          
          <div className="card-footer p-0">
            <ul className="nav flex-column">
              <li className="nav-item"><h6> <a href="#" className="nav-link hover"><i className="fa fa-angle-double-right text-orange"></i>Total Employee<span className="float-right badge bg-primary total_emp"></span> </a></h6> </li>
              {/* <li className="nav-item"><h6> <a href="#" className="nav-link hover"><i className="fa fa-angle-double-right text-orange"></i> Activated <span className="float-right badge bg-info">5</span> </a></h6> </li>
              <li className="nav-item"><h6> <a href="#" className="nav-link hover"><i className="fa fa-angle-double-right text-orange"></i> Pending Profile <span className="float-right badge bg-success">12</span> </a></h6> </li>
              <li className="nav-item"><h6> <a href="#" className="nav-link hover"><i className="fa fa-angle-double-right text-orange"></i> Deactivated <span className="float-right badge bg-danger">42</span> </a></h6> </li> */}
            </ul>
          </div>
          
          {/* <!-- /.widget-user -->  */}
        </div>
      </div>
      <div className="col-lg-10 col-md-10 col-sm-12 col-12">
      <div class="card">
              {/* <!-- /.card-header --> */}
           <div class="card-header bg-cyan">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Employee List</b></h3>
              </div>
                <table class="dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap table-responsive">
                  <thead>
                    <tr class="border">
                      <th>Employee Code</th>
                      <th>Name</th>
                      <th>Role</th>
                      <th>Contact No</th>
                      <th>Pan No</th>
                      <th>Aadhar No</th>
                      <th>Password</th>
                      <th>Address</th>
                      <th>Remarks</th>
                      {/* <th>Status</th> */}
                      {/* <th></th> */}
                    </tr>
                  </thead>
                  <tbody id="tbData">
                    
                  </tbody>
                </table>
             
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Footer/>
<div className="modal fade bd-example-modal-xl"  id="divEmployee" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-xl" role="document">
    <div className="modal-content">
    <div className="modal-header bg-primary">
        <h5 className="modal-title text-white" id="exampleModalLabel">Create New Employee</h5>
        <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" className="text-white">&times;</span>
        </button>
      </div>
      <form id="frmCreate" name="frmCreate">
     
      <div className="modal-body">
      <div className="row">
                {/* <!-- left column --> */}
                <div className="col-md-12">
                    <div className="card card-danger">
                      
                        
                            <input type="hidden" name="res_func" id="res_func" value="okSucc" />
                            <input type="hidden" name="curl_type" id="curl_type" value="addEmployee" />
                            <input type="hidden" name="m_type" id="m_type" value="addEmployee" />
                            <input type="hidden" name="category_id" id="category_id" value="3" />
                            <input type="hidden" name="type_master_id" id="type_master_id" value="10" />
                            <input type="hidden" name="app_user_id" id="app_user_id" value="" />
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Designation *</label>
                                            <div className="input-group input-group-sm">
                                                <select className="form-control" id="category_id" name="category_id">
                                                    <option value="0">-Select-</option>
                                                    <option value="1">ADMIN</option>
                                                    <option value="2">USER</option>
                                                 
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Registered Mobile *</label>
                                            <div className="input-group input-group-sm">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">+91</span>
                                                </div>
                                                <input type="text" className="form-control" id="contact_no" name="contact_no" placeholder="Contact No" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Name *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="person_name" name="person_name" className="form-control" placeholder="Name" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Emp Code *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="user_name" name="user_name" className="form-control" placeholder="Emp Code*" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Aadhar No *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="gstin_no" name="gstin_no" className="form-control" placeholder="Aadhar No." />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">PAN No *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="pan_no" name="pan_no" className="form-control" placeholder="PAN No." />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Address</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="address" name="address" className="form-control" placeholder="Address" />
                                            </div>
                                        </div>
                                    </div>
                                   
                                  
                                    <div className="col-lg-3 col-md-6">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Password *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="password" className="form-control" placeholder="UserName" id="password" name="password" />
                                            </div>
                                        </div>
                                    </div>
                                  
                                </div>
                                <div className="row">
                                    <div className="col-lg-9 col-md-12">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Remark :</label>
                                            <textarea id="details" name="details" className="textarea" placeholder="Place some text here"
                                                      style={{width:"100%",height:"200px",fontSize: "14px",lineHeight:"18px",border:"1px solid #dddddd",padding:"10px"}}></textarea>
                                        </div>
                                    </div>
                                    

                                </div>

                              

                                <div className="col-md-6 respSSL"></div>
                                <div id="testing2dd2222"></div>
                            </div>
                        
                    </div>
                </div>
            </div>
      </div>
      <div className="modal-footer">
      <div id="getReponse" style={{color:"red"}}></div>
        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" className="btn _btnSetColor btn-primary">Save changes</button>
      </div>
      </form>
    </div>
    </div>
    </div>
          </div>)
      }
}
export default List_Employes;